//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import TableKeyValue from '../../components/ui/TableKeyValue.vue';

export default {
  components: {
    TableKeyValue,
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('userP2P', ['p2pInfoTable', 'p2pActivityTable', 'p2pRatingTable']),
    ...mapState('userP2P', ['userP2P']),
  },
};
